import React from "react";

import { Event } from "lib/build/events";

import { api } from "src/common/utils/api";
import { useCreateGenericError } from "src/features/notifications";
import { useOrgModParams } from "src/features/orgmod";
import { PatientConditionValue } from "src/modules/ktx/status-history/types";

interface UsePatientConditionEventsResult {
	isLoading: boolean;
	events: Event<PatientConditionValue>[];
}

export function usePatientConditionEvents(
	patientId: string
): UsePatientConditionEventsResult {
	const { org, mod } = useOrgModParams();
	const [{ isLoading, events }, setState] =
		React.useState<UsePatientConditionEventsResult>({
			isLoading: false,
			events: []
		});
	const createGenericError = useCreateGenericError();
	React.useEffect(() => {
		(async () => {
			setState(state => ({ ...state, isLoading: true }));
			try {
				const { data } = await api.get<
					Event<PatientConditionValue>[] | null
				>(
					`/events/${patientId}?organization=${org}&module=${mod}&i=ktx|committee_opinion_statement&i=ktx|patient_condition_statement`
				);

				setState(state => ({
					...state,
					isLoading: false,
					events: data || []
				}));
			} catch {
				setState(state => ({ ...state, isLoading: false }));
				createGenericError();
			}
		})();
	}, [patientId, org, mod, createGenericError]);
	return { isLoading, events };
}
